import { render, staticRenderFns } from "./interestPoints.vue?vue&type=template&id=73d82fce&scoped=true&"
import script from "./interestPoints.vue?vue&type=script&lang=js&"
export * from "./interestPoints.vue?vue&type=script&lang=js&"
import style0 from "./interestPoints.vue?vue&type=style&index=0&id=73d82fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d82fce",
  null
  
)

export default component.exports